<template>
  <div class="LeiBieList">
    <div class="tableFilter">
      <div style="text-align: right">
        <el-button type="primary" @click="handleAddLeiBie" plain
                   v-show="permissionCode.has('assist:depart:manager')"
        >新增场景
        </el-button>
      </div>
    </div>
    <XTable
        :api="getLeiBieList"
        :state="leiBieList"
        :columns="columns"
        :loading="leiBieListLoading"
        :tableSize="tableSize"
        :maxHeight="maxHeight"
        :firstColumn="firstColumn"
        :layout="layout"
    ></XTable>
    <AddLeiBieModal></AddLeiBieModal>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import XTable from "@/components/XTable/index.vue";
import AddLeiBieModal from "@/pages/BuManagement/AddLeiBieModal.vue";

export default {
  name: "LeiBieList",
  components: {AddLeiBieModal, XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {

    return {
      hasPagination: true,
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: true,
      back: false,
    };
  },
  computed: {
    ...mapState("fuzhu", ["leiBieList", "leiBieListLoading"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "name",
          label: "部门场景",
        },
        {
          label: "编辑日期",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.updateTime)}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('assist:depart:manager')) {
        columns.push({
          label: "调整顺序",
          width: 150,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={self.isUp() && scope.$index === 0}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={self.isDown() === scope.$index}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          }
        });
        columns.push({
          label: "操作",
          fixed: "right",
          width: 200,
          render(h, scope) {
            if (scope.row.noEdit)
              return null;
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("fuzhu", ["getLeiBieList", "deleteLeiBie", "moveLeiBie"]),
    ...mapMutations("fuzhu", ["setData"]),
    isUp() {
      return this.leiBieList.page === 1;
    },
    isDown() {
      return this.leiBieList.total - (this.leiBieList.page - 1) * this.leiBieList.size - 1;
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const offset = (this.leiBieList.page - 1) * this.leiBieList.size + scope.$index + 1;
      this.move;
      await this.moveLeiBie({
        ...this.filter,
        previewDirect: previewDirect,
        offset: offset,
        step: 1,
      }).then(() => {
        this.getLeiBieList({
          ...this.filter,
          page: this.leiBieList.page,
          size: this.leiBieList.size,
        })
      });
    },
    async handleAddLeiBie() {
      this.setData({
        key: "rowDetails",
        value: {},
      });
      this.setData({
        key: "addTagAttributeVisible",
        value: true,
      });
    },
    async handleEdit(row) {
      this.setData({
        key: "rowDetails",
        value: row,
      });
      this.setData({
        key: "addTagAttributeVisible",
        value: true,
      });
    },
    handleDelete(row) {
      this.$confirm("请确认是否要删除该部门场景!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deleteLeiBie({
              id: row.id,
            });
            await this.getLeiBieList({
              page: this.leiBieList.page,
              size: this.leiBieList.size,
            });
          })
          .catch(() => {
          });
    },
    //   根据时间戳计算编辑日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.LeiBieList {
  .tableFilter {
    padding-bottom: 10px;
  }

  .el-form-item {
    margin-right: 20px;
  }

  ::v-deep .el-range-separator {
    width: 20px !important;
  }

  ::v-deep .el-dialog {
    margin-top: 30vh !important;
    width: 500px;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 40px;
  }
}
</style>
